<mat-icon class="copyright-action" (click)="showCopyright($event)">info</mat-icon>
